import "./styles.scss";
import React, {useState, useEffect, useRef} from "react";
import {
    Col,
    Container,
    Row,
    Card,
    CardBody,
    CardText,
    Badge,
    Media,
    CardImg,
} from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png"
import testImage from "assets/images/search.png"
import {appendData} from "store/Mode/actions"
import {MetaTags} from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import {Link} from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Slider from "./Slider";
import CompoundService from "services/Website/CompoundService"
import {SuccessOk} from "configs/statusCode";
import {useSelector, useDispatch} from "react-redux";
import MyMap from "components/Common/google-map/MyMap";
import InteractiveMode from "./InteractiveMode"
import InterActiveModeService from "services/Admin/InterActiveModeService"
import developerdImg from "assets/images/developer_logo.png";
import devCompound from "assets/images/Dev_Compound.png";
import devBuilding from "assets/images/Dev_Building.png";
import devProperty from "assets/images/Dev_Property.png";
import {useTranslation} from 'react-i18next';
import http from "services/HttpService"
import Skeleton from "components/Website/Skeleton"
import SideFilters from "./SideFilters";
import TopFilter from "./TopFilters";
import UnitCard from "components/Website/Cards/UnitCard";
import CardComponent from "./CardCompound";
// import InfiniteScroll from 'react-infinite-scroll-component';
import InfiniteScroll from 'react-infinite-scroller';
import {appendFilters} from "../../../../store/filter/actions";
import Spinner from "components/Website/Spinner";
import Spinner2 from "components/Website/Spinner2";

const CompoundDetails = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const AuthData = useSelector(state => state.Auth)
    const modeData = useSelector(state => state.Mode)
    const [hasMore, setHasMore] = useState(true)
    const [showHighlight, setshowHighlight] = useState(false)
    const [compound, setCompound] = useState(null)
    const [units, setUnits] = useState([])
    const [allUnits, setAllUnits] = useState([])
    const [intractiveUnits, setIntractiveUnits] = useState([])
    const [loadingInteractive, setLoadingIntractive] = useState(false)
    const [loadedMasterImg, setLoadedMasterImg] = useState(false)
    const [carouselUnits, setCarouselUnits] = useState([])
    const [unitTypes, setUnitTypes] = useState([])
    const filterData = useSelector(state => state.filter);
    const [filtersParams, setFilterParams] = useState(null)
    const [topFilterError, setTopFilterError] = useState(false)
    const [showInteractive, setShowInteractive] = useState(false)
    const [isFulllScreenState, setIsFullScreenState] = useState(true)
    const isFulllScreen = useRef(false)
    const [items, setItems] = useState([])
    const {id} = props.match.params;
    const compoundService = new CompoundService()
    const [mapRender, setMapRender] = useState(0)
    const [loading, setLoading] = useState(false);
    const [loadingShowMore, setLoadingShowMore] = useState(false);
    const [fullScreen, setFullScreen] = useState(false);
    const [DetailsLoading, setDetailsLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(0);
    const [totalUnits, setTotalUnits] = useState(0);

    const updateLocationPositions = (lat, lng) => {
        setCompound({...compound, ...{lat, lng}});
    };

    useEffect(()=>{
        setLoading(true)
        compoundService?.getCompoundSpecifications(id).then(response=>{
            if (response && response.status === SuccessOk) {
            dispatch(appendFilters({
                // budgetRange: (response.data.minBudget !== 0 && response.data.maxBudget !== 0) ? (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget] : 0,
                // budget: (response.data.minBudget !== 0 && response.data.maxBudget !== 0) ? (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget] : 0,
                // sizeRange: (response.data.minSize !== 0 && response.data.maxSize !== 0) ? (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)] : 0,
                // size: (response.data.minSize !== 0 && response.data.maxSize !== 0) ? (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)] : 0,
                budgetRange: ((response.data.minBudget == 0 && response.data.maxBudget == 0) || (response.data.minBudget == response.data.maxBudget)) ?  [0,0] : [!parseInt(response.data.minBudget) ? 0 : parseInt(response.data.minBudget), parseInt(response.data.maxBudget)],
                budget: ((response.data.minBudget == 0 && response.data.maxBudget == 0) || (response.data.minBudget == response.data.maxBudget)) ? 0 : [!parseInt(response.data.minBudget) ? 0 : parseInt(response.data.minBudget), parseInt(response.data.maxBudget)],
                sizeRange: ((response.data.minSize == 0 && response.data.maxSize == 0) || (response.data.minSize == response.data.maxSize )) ? [0,0] : [!parseInt(response.data.minSize) ? 0 : parseInt(response.data.minSize), parseInt(response.data.maxSize)],
                size: ((response.data.minSize == 0 && response.data.maxSize == 0) || (response.data.minSize == response.data.maxSize )) ? 0 : [!parseInt(response.data.minSize) ? 0 : parseInt(response.data.minSize), parseInt(response.data.maxSize)],
                bathroomsRange: parseInt(response.data.minBathrooms) !== parseInt(response.data.maxBathrooms) ? [parseInt(response.data.minBathrooms) , parseInt(response.data.maxBathrooms) ] : [parseInt(response.data.minBathrooms)],
                bedroomsRange: parseInt(response.data.minBedrooms) !== parseInt(response.data.maxBedrooms) ? [parseInt(response.data.minBedrooms) , parseInt(response.data.maxBedrooms) ] : [parseInt(response.data.minBedrooms)],
                floorRange: parseInt(response.data.minFloor) !== parseInt(response.data.maxFloor) ? [parseInt(response.data.minFloor) , parseInt(response.data.maxFloor) ] : [parseInt(response.data.minFloor)],
                CategortiesOptions: response.data.categories?.map(type=>{
                return{
                    name: type?.name,
                    value: type?.id,
                    label: type?.name[AuthData?.lang]
                }
                }) ,
                page: 1,
                finishingOptions: response.data.finishing_types ,
                unitTypeOptions: response.data.unit_types?.map(type=>{
                return{
                    name: type?.name,
                    value: type?.id,
                    label: type?.name[AuthData?.lang]
                }
                }) ,
                getRanges:true,
            }))
            }
            setLoading(false)
        })
        
    },[id])

    useEffect(() => {
        setLoading(true)
        // if (filterData.unit?.length) document.getElementById("propertyNamme").blur()
        let params = {}
        if (filterData.unit?.trim().length) params["unit_name"] = filterData.unit.trim()
        params["budget"] = `${Math.round(filterData?.budget[0])}-${Math.round(filterData?.budget[1])}`
        params["area_sizs"] = `${Math.round(filterData?.size[0])}-${Math.round(filterData?.size[1])}`
        if (filterData.floor?.length) params["floors"] = filterData.floor.join()
        if (filterData.bedrooms?.length) params["bedrooms"] = filterData.bedrooms.join()
        if (filterData.bathrooms?.length) params["bathrooms"] = filterData.bathrooms.join()
        if (filterData.paymentMethods?.length) params["payment_type"] = filterData.paymentMethods.join()
        if (filterData.categories_ids?.length) params["category_ids"] = formatParamsHandler(filterData.categories_ids)
        if (filterData.finishingType?.length) params["finishing_type_ids"] = formatParamsHandler(filterData.finishingType)
        if (filterData.unitType?.length) params["unit_type_ids"] = formatParamsHandler(filterData.unitType)

        if(filterData?.getRanges){
            setFilterParams({...params})
            setLoading(false)
        }
    }, [filterData])

    const isExist = (arr, id) => {
        const element = arr?.find(item => {
            return item.id === id
        })
        if (element) {
            return true
        } else {
            return false
        }
    }

    // FullScreenElement
    useEffect(() => {
        document.addEventListener('fullscreenchange', () => {
            // document.fullscreenElement will point to the element that
            // is in fullscreen mode if there is one. If there isn't one,
            // the value of the property is null.
            if (document.fullscreenElement) {
                isFulllScreen.current = true
                setIsFullScreenState(true)
                // document.body.style.overflow = 'hidden';
            } else {
                isFulllScreen.current = false
                setIsFullScreenState(false)
                setFullScreen(false)
                document.body.style.overflow = 'scroll';
            }
            // isFulllScreen.current=!isFulllScreenState
        });

    }, [])

    // useEffect(()=>{
    //     setIntractiveUnits([])
    // },[filterData.unitType, filterData.finishingType, filterData.categories_ids, filterData.paymentMethods,
    //    filterData.bathrooms, filterData.bedrooms, filterData.floor, filterData.size, filterData.budget, filterData.unit])

    useEffect(() => {
        if (!!filtersParams && filterData.getRanges) {
            const types = []
            http.setLang()
            setLoading(true)
            let params ={...filtersParams, per_page: filterData.per_page, page: filterData.page}
            compoundService.find(id, {...params}).then((response) => {
                if (response && response.status === SuccessOk) {
                    setCompound({...response.data.compound})
                    response.data.units?.data.forEach((unit, index) => {
                        if (!isExist(types, unit.unit_type.id)) {
                            types.push(unit.unit_type)
                        }
                    })
                    setUnitTypes([...types])
                    if (filterData.page == 1) {
                        setUnits([...response.data.units.data])
                        setAllUnits([...response.data.units.data])
                    } else {
                        setAllUnits((data) => [...data, ...response.data.units.data])
                    }
                    setTotalPages(Math.ceil(response.data.units.meta.total / filterData.per_page+1))
                    setMapRender(mapRender + 1)
                    setLoading(false)
                    setDetailsLoading(false)
                    setLoadingShowMore(false)
                    if([...allUnits, ...response.data.units.data]?.length < response?.data?.units?.meta?.total){
                        setHasMore(true)
                    } else {
                        setHasMore(false)
                    }
                    if(!filterData.unitType?.length && !filterData.finishingType?.length && !filterData.categories_ids?.length &&
                        !filterData.floor?.length && !filterData.bedrooms?.length && !filterData.bathrooms?.length){
                        setTotalUnits(response?.data?.units?.meta?.total)
                    }
                }
            })
        }
    }, [filtersParams])

    const getAllUnits = () =>{
        setLoadingIntractive(true)
        compoundService.find(id, {budget: filtersParams.budget, area_sizs: filtersParams.area_sizs, per_page: totalUnits}).then((response) => {
            if (response && response.status === SuccessOk) {
                setIntractiveUnits([...response.data.units.data])
                setShowInteractive(true)
                setLoadingIntractive(false)
            }
        })
    }

    useEffect(() => {
        let unitsArray = units.map((item, index) => index < 11 && item)
        unitsArray.push({})
        setCarouselUnits(unitsArray)
    }, [units])

    useEffect(async () => {
        if (id) {
            new InterActiveModeService().getInteractiveModeSite(id).then(res => {
                if (res?.data?.length) {
                    const data = res.data[0]
                    const master = data?.images?.find(item => item?.image?.id === data?.main_image?.id)
                    dispatch(appendData({
                            compound: modeData.compound,
                            currentImge: {
                                id: master?.image?.id,
                                path: master?.imagepath
                            },
                            masterImg: {
                                id: master?.image?.id,
                                path: master?.image?.path
                            },
                            images: res.data[0]?.images?.map(img => ({
                                ...img,
                                ...img?.image,
                                image: null

                            }))
                        }
                    ))
                }
            })
        }
    }, [id])

    useEffect(() => {
        const data = compound?.images?.map((img, index) => {
            return {
                src: img.path,
                altText: `Slide ${index + 1}`,
                caption: `Slide ${index + 1}`,
            }
        })
        setItems(data)
    }, [compound])

    // useEffect(() => {
    //     if (isFulllScreenState) {
    //         document.getElementById("canvas").scrollIntoView()
    //         //  disableBodyScroll()
    //         setTimeout(() => {
    //             document.body.style.overflow = 'hidden';
    //         }, [1000])
    //     } else {
    //         // enableBodyScroll()
    //     }
    //     // return () => {
    //     //   clearAllBodyScrollLocks();
    //     // };

    // }, [isFulllScreenState])

    const toggleFullscreen = () => {
        if (
            !document.fullscreenElement &&
            /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            setFullScreen(true)
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen()
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen()
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                )
            }
        } else {
            setFullScreen(false)
            if (document.cancelFullScreen) {
                document.cancelFullScreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen()
            }
        }
    }

    useEffect(()=>{
        window.scrollTo({
            left: 0,
            behavior: "smooth",
        });
    },[])

    if (DetailsLoading) {
        return <Skeleton.CompoundDetails history={props.history}/>
    }

    const fetchMoreData = () => {
        setLoadingShowMore(true)
        if (filterData.page + 1 <= totalPages) {
            dispatch(appendFilters({page: filterData.page + 1}))
        }
    };

    return (
        <div className='websitPages  details'>
            <MetaTags>
                <title>{t("Compound details Page")}</title>
            </MetaTags>
            <div>
                <Container fluid className='pb-5 pt-5 mt-4'>
                    <div className="d-flex py-3 px-lg-2">
                        <button className="p-0 m-0 border-0 me-2"
                                style={{background: 'none'}}
                                onClick={() => {
                                    props.history.goBack()
                                }}>
                                    <i className="fa fa-arrow-left text-success me-2 font-size-16"></i>
                        </button>
                        <CardText tag="h4" className="fw-bold text-primary pb-2">{t("compound details")}</CardText>
                    </div>
                    <Row>
                        <Col md={3}>
                            <SideFilters id={id} loading={loading} setLoading={setLoading} type="Unit"/>
                        </Col>
                        <Col md={9}>
                            <Row>
                                {items && items.length >= 3 &&
                                    <Row>
                                        <Col md={7}>
                                            <Slider items={items}/>
                                        </Col>
                                        <Col md={5}>
                                            {compound && compound?.images?.map((img, index) => {
                                                if (index < 2) {
                                                    return <img key={index} src={img?.path} className='samHeight midImage '
                                                                style={{marginTop: index === 1 ? "1.5rem" : 0}}/>

                                                }
                                            })}

                                        </Col>
                                    </Row>}
                                {items && items.length === 2 &&
                                    <Row>
                                        {compound && compound?.images?.map((img, index) => {
                                            if (index < 2) {
                                                return (
                                                    <Col md={6} key={index}>
                                                        <img src={img?.path} className='midImage  my-2'
                                                             style={{height: "500px"}}/>
                                                    </Col>
                                                )
                                            }
                                        })}
                                    </Row>}
                                {items && items.length === 1 &&
                                    <Row>
                                        {/*{compound && compound?.images?.map((img, index) => {*/}
                                        {/*  if (index == 0) {*/}
                                        {/*    return (*/}
                                        {/*      <Col md={12} key={index}>*/}
                                        {/*        <img src={img?.path} className="img-responsive2" />*/}
                                        {/*      </Col>*/}
                                        {/*    )*/}
                                        {/*  }*/}
                                        {/*})}*/}
                                        {compound &&
                                            <Col md={12}>
                                                <img src={compound?.images?.[0].path} className="img-responsive2"/>
                                            </Col>
                                        }
                                    </Row>}
                                {compound && compound?.images.length === 0 &&
                                    <Row>
                                        <Col md={12}>
                                            <img src={compoundImg} className="img-responsive2"/>
                                        </Col>
                                    </Row>}
                            </Row>
                            <Row className='pt-4'>
                                <Col md={8} className='bg-white p-3'>
                                    <CardText tag='h3'>
                                        {AuthData.lang && unitTypes?.map((unit, index) => {
                                            return <Badge key={index}
                                                          className='bgBadge font-size-12'>{unit?.name[`${AuthData.lang}`] ? unit?.name[`${AuthData.lang}`] : unit?.name?.en}</Badge>
                                        })}
                                        <span className='text-muted font-size-14 mx-2'>
                      {compound?.installment ? t("up to installment", {num: compound?.installment}) : t("only cash")}
                    </span>
                                    </CardText>
                                    <CardText tag='h2' className='text-black fw-bold mt-3'>
                                        {compound?.name[`${AuthData.lang}`] ?
                                            compound?.name[`${AuthData.lang}`]
                                            :
                                            compound?.name?.en
                                        }
                                    </CardText>
                                    <CardText tag='p'>
                                        <i className='fa fa-map-marker-alt text-primary  mt-3'></i>
                                        <span
                                            className="px-1"> {compound?.address[`${AuthData.lang}`] ? compound?.address[`${AuthData.lang}`] : compound?.address?.en},
                                            {compound?.area?.name[`${AuthData.lang}`] ? compound?.area?.name[`${AuthData.lang}`] : compound?.area?.name?.en},
                                            {compound?.city?.name[`${AuthData.lang}`] ? compound?.city?.name[`${AuthData.lang}`] : compound?.city?.name?.en}
                    </span>
                                    </CardText>
                                    <CardText tag='p' className='text-muted mb-0 mt-3'>
                                        {t("starting from")}
                                    </CardText>
                                    <CardText tag='h2' className='fw-bold text-black mb-3'>
                                        {compound && toCurrency(compound.starting_from)}
                                    </CardText>
                                    <CardText tag='p' className="mt-3">
                                        {compound?.description[`${AuthData.lang}`] ?
                                            compound?.description[`${AuthData.lang}`] :
                                            compound?.description?.en
                                        }
                                    </CardText>
                                </Col>
                                <Col md={4}>
                                    <Card>
                                        <CardBody>
                                            <Media>
                                                {compound?.developer?.media?.path ?
                                                    <img src={compound.developer.media.path} width="60" height="50"
                                                         className='pe-2'/>
                                                    : <img src={developerdImg} className='pe-2' height="40"/>
                                                }
                                                <Media body>
                                                    <span
                                                        className='text-muted mb-0 mx-3'>{t("hosted in")} {new Date(compound?.created_at).toLocaleDateString(`${AuthData.lang}`, options)}</span>
                                                    <h5 className='font-size-16 mb-1 mx-3'>
                                                        {compound?.developer?.name[`${AuthData.lang}`] ?
                                                            compound?.developer?.name[`${AuthData.lang}`] :
                                                            compound?.developer?.name?.en
                                                        }
                                                    </h5>
                                                </Media>
                                            </Media>
                                            <hr/>
                                            <CardText tag='h6' className='pb-2'>
                                                <img src={devCompound} className='pe-2' height="25"/>
                                                <span> {compound?.developer?.compounds_count} {t("compounds")}</span>
                                            </CardText>
                                            <CardText tag='h6' className='pb-2'>
                                                <img src={devBuilding} className='pe-2' height="25"/>
                                                <span> {compound?.developer?.buildings_count} {t("buildings")}</span>
                                            </CardText>
                                            <CardText tag='h6' className='pb-2'>
                                                <img src={devProperty} className='pe-2' height="25"/>
                                                <span> {compound?.developer?.units_count} {t("property")}</span>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <div className='bgGray mt-3 p-3'>
                                <CardText tag='h3' className='text-primary py-2 fw-bold '>
                                    {t("compound amenities")}
                                </CardText>
                                <Row>
                                    {compound && compound.facilities?.map((item, index) => {
                                        return (
                                            <Col xl={3} lg={3} md={4} xs={6} key={index}>
                                                <Card className='mt-2'>
                                                    <CardBody className='text-center p-2'>
                                                        <CardText className="font-size-16 fw-bold">
                                                            {item?.name[`${AuthData.lang}`] ?
                                                                item?.name[`${AuthData.lang}`] :
                                                                item?.name?.en
                                                            }
                                                        </CardText>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <Card className="mt-4 px-3" dir={AuthData.lang === "ar" ? "rtl" : "ltr"}>
                        <CardText tag='h3' className='text-primary pt-4  fw-bold mb-0'>
                            {t("matching units")}
                        </CardText>
                        {units?.length > 0 ? <Carousel
                            className='pb-3 mb-4'
                            swipeable={true}
                            draggable={true}
                            showDots={true}
                            responsive={responsive}
                            infinite={false}
                            autoPlaySpeed={1000}
                            keyBoardControl={true}
                            customTransition='all .5'
                            transitionDuration={500}
                            customRightArrow={<CustomRight/>}
                            customLeftArrow={<CustomLeft/>}
                            containerClass='carousel-container'
                            removeArrowOnDeviceType={[]}
                            dotListClass='custom-dot-list-style'
                            itemClass='carousel-item-padding-40-px width-item'>

                            {allUnits.map((unit, index) => {
                                if (index < 11) {
                                    return (
                                        <UnitCard item={{
                                                ...unit,
                                                city: compound.city,
                                                area: compound.area,
                                                address: compound.address,
                                                length: units?.length
                                            }}
                                                index={index}
                                                key={index}
                                                history={props.history}/>
                                    )
                                }
                            })}
                            <a href="#interactive" className="underlinedText">
                                <Card className="comCard mb-4 overflow-hidden">
                                    <CardImg src={testImage}  ></CardImg>
                                        <CardBody className="text-center pt-5 mt-2">
                                        <div className="maxBodyHeightNew">
                                            <p 
                                                style={{
                                                    fontWeight: 800,
                                                    fontSize: '16px', position: "absolute",
                                                    top: "66%", left: '50%',
                                                    transform: "translate(-50%, -50%)"
                                                }}>
                                                    <i className="fas me-1 fa-search"></i> {t("Explore more")}
                                                </p>
                                        </div>
                                    </CardBody>
                                </Card>
                            </a>

                        </Carousel> : <p className="font-size-16 px-2 ">{t("no match units")}</p>}
                    </Card>
                    <Card className="px-3 pb-3">
                        <CardText tag='h3' className='text-primary   fw-bold mt-4'>
                            {t("Buy your Unit Inside Project")}
                        </CardText>
                        <span className='mt-1 my-2'>{t("interactive subtitle")}</span>
                        <Row>
                            <Col md={12} className='mt-3'>
                                <TopFilter topFilterError={topFilterError} setTopFilterError={setTopFilterError} id={id} loading={loading} setLoading={setLoading} type="Unit" />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="6" className="pt-lg-4 pt-3 newShadow mt-3">
                                <Card className="border mb-2">
                                    <CardBody className="maxHeightCard px-1 pt-2">
                                        <div>
                                            <InfiniteScroll
                                                // dataLength={totalUnits}
                                                pageStart={0}
                                                // next={fetchMoreData}
                                                hasMore={true}
                                                // scrollThreshold={.8}
                                                useWindow={false}
                                                loadMore={()=>{}}
                                                loader={(filterData.page + 1 <= totalPages && !loadingShowMore) &&
                                                    <div className="loader font-size-14 text-center" 
                                                        onClick={()=> fetchMoreData()}
                                                    >
                                                        See More
                                                    </div>}
                                            >
                                                {allUnits.map((unit, index) => <CardComponent key={index} item={unit}
                                                                                            history={props.history}/>)}
                                            </InfiniteScroll>
                                            {loadingShowMore && <div className="position-relative pt-2 pb-2">
                                                <Spinner2></Spinner2>
                                            </div>}
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="6" className="position-relative">
                                {modeData?.masterImg?.path ?
                                        <div id='interactive' className="position-relative mt-3 "
                                             style={{height: "30rem", objectFit: "cover"}}>
                                            <div className="shape-container"
                                                 style={{
                                                     border: showHighlight ? "2px #0d6efd solid" : "2px transparent solid",
                                                     background: showHighlight ? "rgba(13, 110, 253, .3)" : "none"
                                                 }}>
                                                <div className="mouse_container" onClick={() => {
                                                    if(filterData.unitType?.length == 0 && filterData.finishingType.length == 0 &&
                                                        filterData.categories_ids.length == 0 && filterData.floor.length == 0 &&
                                                        filterData.bedrooms.length == 0 && filterData.bathrooms.length == 0){
                                                            setTopFilterError(true)
                                                            window.scrollTo({
                                                                top: 1950, //1540
                                                                left: 0,
                                                                behavior: "smooth",
                                                            });
                                                    } else {
                                                            if(intractiveUnits?.length == 0){
                                                                getAllUnits()
                                                            } else if(!loadingInteractive && loadedMasterImg) {
                                                                document.body.style.overflow = 'hidden';
                                                                setShowInteractive(true)
                                                            }
                                                    }
                                                }}>
                                                    {loadingInteractive ? <Spinner2></Spinner2> : <>
                                                    <i className="fas fa-mouse fa-4x text-white" style={{margin: "65px 78px 0px 77px"}}></i>
                                                    <br/>
                                                    <span className="d-block fw-bold font-size-16 text-white text-center" style={{marginTop: "10px"}}>
                                                        Interactive Mode 
                                                    </span>
                                                    </>}
                                                </div>
                                            </div>
                                            <img style={{borderRadius: "10px", padding: 0, width: "100%", height: "100%"}}
                                                 onClick={() => {
                                                     setshowHighlight(true)
                                                     setTimeout(() => {
                                                         setshowHighlight(false)
                                                     }, 250);
                                                 }}
                                                 onLoad={()=> {
                                                    if(!loadingInteractive && showInteractive){
                                                        document.body.style.overflow = 'hidden';
                                                        setShowInteractive(true)
                                                    }
                                                    setLoadedMasterImg(true)
                                                 }}
                                                 src={modeData?.masterImg?.path}/>
                                                 {/* <Skeleton.Interactive inline={true} width='100%' height= '30rem' /> */}
                                        </div> :
                                        <div style={{
                                            height:'30rem',
                                            border: '1px solid #dedede',
                                            borderRadius: '10px'
                                            }}
                                            className='mt-3 position-relative'>
                                                <h4 style={{
                                                    position: 'absolute',
                                                    top:'50%',
                                                }}
                                                className='w-100 text-center'>Interactive mode hasn't been added yet</h4>
                                        </div>}
                                {/* {(loadingInteractive) && <div 
                                        style={{ height: '30rem', background:'#F8F8FB', zIndex: '9999', top: '0'}} 
                                        className="d-flex w-100 mt-3 justify-content-center position-absolute" >
                                    <Spinner2></Spinner2>
                                </div>} */}
                            </Col>
                        </Row>
                        {(!loadingInteractive && showInteractive && intractiveUnits?.length > 0) && <InteractiveMode
                                developer={compound?.developer}
                                allUnits= {intractiveUnits}
                                city={compound?.city?.name}
                                setFullScreen={setFullScreen}
                                setShowInteractive={setShowInteractive}
                                address={compound?.address}
                                history={props.history}
                                compound={compound}
                                area={compound?.area?.name}
                            />}
                    </Card>

                    {mapRender && <Card className='pt-3'>
                        <h3 className='text-primary fw-bold mb-0 ms-3'>
                            {t("location")}
                        </h3>
                        <CardBody>
                            <MyMap
                                updateLocationPositions={updateLocationPositions}
                                lat={compound.lat}
                                lng={compound.lang}
                            />
                        </CardBody>
                    </Card>}
                    {compound && compound.videos.length !== 0 &&
                        <Card>
                            <h3 className='text-primary ms-3 mb-0 fw-bold mt-3'>
                                {t("vedio")}
                            </h3>
                            <CardBody>
                                {compound.videos.map((video, index) => {
                                    return (
                                        <div className="my-2" key={index}>
                                            <video
                                                style={{
                                                    display: "block",
                                                    width: "100%",
                                                }}
                                                controls>
                                                <source src={video.path} type='video/mp4'/>
                                            </video>
                                        </div>
                                    )
                                })}
                            </CardBody>
                        </Card>}

                </Container>
            </div>
        </div>
    );
};

const CustomRight = ({onClick}) => (
    <button onClick={onClick} className="bg-white arrow right border-0">
        <i className="fas fa-arrow-alt-circle-right text-primary fa-2x"></i>
    </button>
);
const CustomLeft = ({onClick}) => (
    <button onClick={onClick} className="bg-white arrow left border-0">
        <i className="fas fa-arrow-alt-circle-left text-primary fa-2x"></i>
    </button>
);
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: {max: 4000, min: 3000},
        items: 4,
        slidesToSlide: 3
    },
    desktopLg: {
        breakpoint: {max: 3000, min: 1300},
        items: 4,
        slidesToSlide: 3
    },
    desktop: {
        breakpoint: {max: 1300, min: 1100},
        items: 3,
        slidesToSlide: 3
    },
    tablet: {
        breakpoint: {max: 1100, min: 600},
        items: 2,
        slidesToSlide: 2
    },
    mobile: {
        breakpoint: {max: 600, min: 0},
        items: 1,
        slidesToSlide: 1
    },
};
const formatParamsHandler = (data) => {
    let value = ""
    for (let i = 0; i < data.length; i++) {
        if (i === 0) {
            value = data[i].id ?? data[i].value
        } else {
            value = `${value},${data[i].id ?? data[i].value}`
        }
    }
    return value
}
const options = {
    year: 'numeric',
    month: 'short',
};

export default CompoundDetails;